// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__+FwH3","item":"style_item__mvqoA","title":"style_title__hG692","categories":"style_categories__SoueY"};